import useTranslation from 'next-translate/useTranslation';
import { RichText } from 'components/atoms/RichText';
import { pdfCss } from './TagesPlanPdfDownload.styles';
import { TagesPlanPdfDownloadProps } from './TagesPlanPdfDownload.types';
import { ButtonStyled, PdfContentStyled } from './TagesPlanPdfDownload.styles';

export const TagesPlanPdfDownload: React.FC<TagesPlanPdfDownloadProps> = ({
  className,
  slices,
  content,
}) => {
  const { t } = useTranslation('common');

  const safeSlices = Array.isArray(slices) ? slices : [];
  const sliceItem = safeSlices.find((slice) => slice.slice_type === 'tagesplan-pdf');

  const openPreview = () => {
    var pdfContentMarkup = document.getElementById('pdfContent');
    var win = window.open('', '_blank');

    if (pdfContentMarkup && win) {
      const printWindow = win;
      printWindow.opener = null;
      printWindow.document.write('<html><head><title>Ballenberg Tagesplan</title>');
      printWindow.document.write(`<base href="${window.location.origin}">`);
      printWindow.document.write(`<style type="text/css">${pdfCss}</style>`);
      printWindow.document.write('</head><body>');

      // Create a copy of the innerHTML
      const currentContent = pdfContentMarkup.innerHTML;
      const patternToReplace = /(\d{2}):(\d{2}) - (\d{2}):(\d{2})/g;
      const replacementString = '$1.$2 - $3.$4';

      // Perform the replacement on the copy
      const modifiedContent = currentContent.replace(patternToReplace, replacementString);

      // Use the modified copy for the print operation
      printWindow.document.write(modifiedContent);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      const doPrint = () => {
        printWindow.focus();
        printWindow.print();
      };

      if (
        printWindow.document.fonts &&
        typeof printWindow.document.fonts.ready?.then === 'function'
      ) {
        printWindow.document.fonts.ready.then(doPrint).catch(doPrint);
      } else {
        setTimeout(doPrint, 0);
      }

      return true;
    }
  };
  return (
    <>
      <ButtonStyled
        skin="primary"
        icon="DOWNLOAD"
        className={className}
        onClick={() => openPreview()}
      >
        {t('pdfDownload')}
      </ButtonStyled>
      <PdfContentStyled>
        <div id="pdfContent">
          {content}

          <div className="pdf-footer">
            {sliceItem && <RichText rich_text={sliceItem.primary['pdf-content']} />}
          </div>
        </div>
      </PdfContentStyled>
    </>
  );
};
